import dayjs, { type Dayjs } from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";

import { DATE_FORMATS, NO_DATA } from "shell/platform/constants/constants";

dayjs.extend(isoWeek);

export const splitDayInIntervals = (
  intervalMinutes: number,
): Array<{ label: string; value: string }> => {
  const result = [];
  const start = dayjs().startOf("day");
  for (let i = 0; i < 24 * 60; i += intervalMinutes) {
    const d = start.add(i, "minute");
    result.push({ label: d.format("hh:mm A"), value: d.format("HH:mm:ss") });
  }
  return result;
};

export const isValidDate = (date: string | number | Date): boolean =>
  dayjs(date).isValid();

export const formatDateToCustomFormat = (
  isoString: string | number,
  format: string = DATE_FORMATS.DATE_TIME_24H,
) => {
  if (isoString === NO_DATA) return isoString;
  const date = dayjs(isoString);
  if (!date.isValid()) return NO_DATA;
  return date.format(format);
};

export const formatDateOrTimestampSeconds = (
  value: string | { seconds: number } | null | undefined,
  format?: string,
) => {
  if (!value) return NO_DATA;

  const dateValue = typeof value === "string" ? value : value.seconds * 1000;

  return formatDateToCustomFormat(dateValue, format);
};

export const toIsoStringFromRestTimestamp = (
  value: string | { seconds: number } | null | undefined,
): string | undefined => {
  if (!value) return;

  const dateValue = typeof value === "string" ? value : value.seconds * 1000;
  const date = dayjs(dateValue);

  if (!date.isValid()) return;
  return date.toISOString();
};

export const getMonthYearFromDateYmd = (
  date?: { month?: number; year?: number } | null,
): string => {
  if (!date?.month || !date?.year) return "Invalid date";
  return `${date.month}/${date.year}`;
};

export const getDatefromDateYmd = (
  date: { day?: number; month?: number; year?: number } | undefined,
) => {
  if (!date) return "Invalid Date";

  const { day, month, year } = date;

  return `${day} ${dayjs()
    .month(Number(month) - 1)
    .format("MMM")} ${year}`;
};

export const getWeekRange = (now: Dayjs) => ({
  start: now.startOf("isoWeek"),
  end: now.endOf("isoWeek"),
});

export const getMonthInfo = (now: Dayjs) => {
  const end = now.endOf("month");
  return {
    start: now.startOf("month"),
    end,
    totalDays: end.date(),
  };
};
